import { memo } from 'react';
import { ui } from '@procuros/datachecks';
import classNames from 'classnames';

import { DisplayModes } from 'components/DataTable/Types';
import { WebEDISection } from 'components/WebEDI/WebEDISection/WebEDISection';

import { SchemableForm } from '../../SchemableForm/SchemableForm';
import { DocumentSectionError } from '../DocumentSectionError/DocumentSectionError';

export const DocumentHeaderInfo = memo(
  ({ config, mode, isSubmitting }: { config: ui.InfoSection; mode: DisplayModes; isSubmitting: boolean }) => {
    if (!config.fields?.length) {
      return null;
    }

    return (
      <WebEDISection
        header={config.label ? { title: config.label, description: config.description, spacing: 'medium' } : undefined}
      >
        <div className="space-y-4 [container-type:inline-size]">
          <DocumentSectionError path="info" sectionConfig={config} />
          <div className={classNames('grid gap-4 grid-cols-2 @[640px]:grid-cols-3 @[900px]:grid-cols-4')}>
            <SchemableForm dataPathPrefix="info.0" config={config} mode={mode} isSubmitting={isSubmitting} />
          </div>
        </div>
      </WebEDISection>
    );
  },
);

DocumentHeaderInfo.displayName = 'DocumentHeaderInfo';
